/* ==========================================================
   ParentRecord™ Landing — INTERNATIONAL (AU / CA / UK)
   File: assets/parentrecord-landing-intl.js

   Delta rispetto alla versione USA:
   1. BUNDLE_LANDING_URL = window.location.pathname
      → cliccando il bundle nel drawer si resta sulla landing
        internazionale (qualunque sia il suo handle Shopify),
        invece di tornare alla homepage USA "/".
   2. Social-proof popup: location AU/CA/UK invece degli stati USA.

   Il resto è identico alla versione USA:
   • Drawer con immagini e titoli prodotto cliccabili
   • Badge carrello floating
   • Upsell "Court Week Calm Protocol" con prezzo in valuta locale
   • formatMoney usa Intl.NumberFormat + cartCurrency (da /cart.js)
     → Shopify Markets converte automaticamente in AUD/CAD/GBP
   • Qty, remove, checkout link

   NOTA UPSELL:
   COURTWEEK_HANDLE deve corrispondere all'handle reale del
   prodotto "Court Week Calm Protocol" su Shopify (lo trovi
   nell'URL della pagina prodotto, dopo /products/). Se non
   corrisponde, la card upsell non recupera i dati e non
   viene mostrata — nessun errore visibile, va corretto qui.
   ========================================================== */

(function () {
  'use strict';

  var VARIANT_ID = '56837249597764';

  /* URL della landing internazionale: si usa la pagina corrente
     così il link del bundle nel drawer funziona sempre,
     indipendentemente dall'handle Shopify scelto. */
  var BUNDLE_LANDING_URL = window.location.pathname;

  /* ── Upsell config ───────────────────────────────────────── */
  var MAIN_BUNDLE_VARIANT_ID = VARIANT_ID;
  var COURTWEEK_VARIANT_ID   = '56859007746372';
  var COURTWEEK_HANDLE       = 'court-week-calm-protocol';

  var courtweekProductCache  = null;
  var upsellAdding           = false;
  var currentCart            = null;

  /* ── Helpers ─────────────────────────────────────────────── */
  var cartCurrency = 'USD'; // aggiornato al primo fetch di /cart.js

  function formatMoney(cents) {
    var amount = cents / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: cartCurrency,
        currencyDisplay: 'narrowSymbol'
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + ' ' + cartCurrency;
    }
  }

  /* ── Drawer state ────────────────────────────────────────── */
  var drawer       = document.getElementById('prDrawer');
  var overlay      = document.getElementById('prDrawerOverlay');
  var drawerBody   = document.getElementById('prDrawerBody');
  var drawerFooter = document.getElementById('prDrawerFooter');
  var drawerSub    = document.getElementById('prDrawerSubtotal');
  var closeBtn     = document.getElementById('prDrawerClose');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('pr-open');
    overlay.classList.add('pr-open');
    document.body.classList.add('pr-drawer-open');
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('pr-open');
    overlay.classList.remove('pr-open');
    document.body.classList.remove('pr-drawer-open');
  }

  if (closeBtn)  closeBtn.addEventListener('click', closeDrawer);
  if (overlay)   overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ── Upsell: helpers ─────────────────────────────────────── */
  function cartHasVariant(cart, variantId) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function (item) {
      return String(item.variant_id) === String(variantId);
    });
  }

  function fetchCourtweekProduct(callback) {
    if (courtweekProductCache) { callback(courtweekProductCache); return; }
    fetch('/products/' + COURTWEEK_HANDLE + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('Product fetch failed'); return r.json(); })
      .then(function (product) {
        courtweekProductCache = product;
        callback(product);
      })
      .catch(function () { callback(null); });
  }

  function renderUpsellCard(cart) {
    var existing = drawerBody.querySelector('.pr-drawer-upsell');
    if (existing) existing.remove();

    var showUpsell = cartHasVariant(cart, MAIN_BUNDLE_VARIANT_ID) && !cartHasVariant(cart, COURTWEEK_VARIANT_ID);
    if (!showUpsell) return;

    fetchCourtweekProduct(function (product) {
      if (!product) return;
      if (drawerBody.querySelector('.pr-drawer-upsell')) return;
      if (!cartHasVariant(currentCart, MAIN_BUNDLE_VARIANT_ID) || cartHasVariant(currentCart, COURTWEEK_VARIANT_ID)) return;

      var variant      = product.variants && product.variants[0];
      var variantId    = variant ? variant.id : COURTWEEK_VARIANT_ID;
      var price        = variant ? variant.price : product.price;
      var comparePrice = variant ? variant.compare_at_price : product.compare_at_price;
      var image        = product.featured_image || (product.images && product.images[0]) || null;

      var oldPriceHtml = (comparePrice && comparePrice > price)
        ? '<span class="pr-upsell-price-old">' + formatMoney(comparePrice) + '</span>'
        : '';

      var productUrl = '/products/' + COURTWEEK_HANDLE;

      var imgHtml = image
        ? '<a href="' + productUrl + '" class="pr-upsell-img-link"><img class="pr-upsell-img" src="' + image + '" alt="' + product.title + '" loading="lazy"></a>'
        : '<div class="pr-upsell-img-ph"></div>';

      var card = document.createElement('div');
      card.className = 'pr-drawer-upsell';
      card.innerHTML =
        '<div class="pr-upsell-label">Parents preparing for court also add</div>' +
        '<div class="pr-upsell-row">' +
          imgHtml +
          '<div class="pr-upsell-info">' +
            '<a href="' + productUrl + '" class="pr-upsell-title-link"><div class="pr-upsell-title">' + product.title + '</div></a>' +
            '<div class="pr-upsell-sub">7-day planner + court scripts</div>' +
            '<div class="pr-upsell-price">' + oldPriceHtml + formatMoney(price) + '</div>' +
          '</div>' +
          '<button class="pr-upsell-add" type="button" data-variant-id="' + variantId + '">Add +</button>' +
        '</div>';

      drawerBody.appendChild(card);

      card.querySelector('.pr-upsell-add').addEventListener('click', function () {
        if (upsellAdding) return;
        addUpsellToCart(variantId, this);
      });
    });
  }

  function addUpsellToCart(variantId, btn) {
    upsellAdding = true;
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Add failed');
      return r.json();
    })
    .then(function () {
      fetchCart(renderCart);
    })
    .catch(function () {
      upsellAdding = false;
      btn.disabled = false;
      btn.textContent = originalText;
    });
  }

  /* ── Render cart items ───────────────────────────────────── */
  function renderCart(cart) {
    if (!drawerBody) return;
    currentCart = cart;
    upsellAdding = false;

    if (!cart.items || cart.items.length === 0) {
      drawerBody.innerHTML = '<div class="pr-drawer-empty">Your cart is empty.<br>Add the bundle to get started.</div>';
      if (drawerFooter) drawerFooter.style.display = 'none';
      updateCartTrigger(cart);
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      /* Bundle principale → landing intl corrente; altri prodotti → loro pagina */
      var isBundleItem = String(item.variant_id) === String(MAIN_BUNDLE_VARIANT_ID);
      var itemUrl = isBundleItem ? BUNDLE_LANDING_URL : ('/products/' + item.handle);

      var imgHtml = item.image
        ? '<a href="' + itemUrl + '" class="pr-drawer-item-img-link"><img class="pr-drawer-item-img" src="' + item.image + '" alt="' + item.title + '" loading="lazy"></a>'
        : '<div class="pr-drawer-item-img-ph">No image</div>';

      var originalPrice = item.original_price !== item.final_price
        ? '<span class="pr-drawer-item-price-old">' + formatMoney(item.original_price) + '</span>'
        : '';

      html += '<div class="pr-drawer-item" data-key="' + item.key + '">';
      html += imgHtml;
      html += '<div class="pr-drawer-item-info">';
      html += '<a href="' + itemUrl + '" class="pr-drawer-item-title-link"><div class="pr-drawer-item-title">' + item.product_title + '</div></a>';
      html += '<div class="pr-drawer-item-price">' + originalPrice + formatMoney(item.final_price) + '</div>';
      html += '<div class="pr-drawer-qty-row">';
      html += '<div class="pr-drawer-qty">';
      html += '<button class="pr-qty-minus" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>';
      html += '<span>' + item.quantity + '</span>';
      html += '<button class="pr-qty-plus" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>';
      html += '</div>';
      html += '<button class="pr-drawer-remove" data-key="' + item.key + '" data-qty="0">Remove</button>';
      html += '</div>';
      html += '</div>';
      html += '</div>';
    });

    drawerBody.innerHTML = html;

    if (drawerSub)    drawerSub.textContent = formatMoney(cart.total_price);
    if (drawerFooter) drawerFooter.style.display = 'block';
    updateCartTrigger(cart);

    /* Qty / remove buttons */
    drawerBody.querySelectorAll('.pr-qty-minus, .pr-qty-plus, .pr-drawer-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var qty = parseInt(btn.getAttribute('data-qty'), 10);
        updateItem(key, qty);
      });
    });

    renderUpsellCard(cart);
  }

  /* ── Fetch current cart ──────────────────────────────────── */
  function fetchCart(callback) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.currency) cartCurrency = cart.currency;
        callback(cart);
      })
      .catch(function () {
        if (drawerBody) drawerBody.innerHTML = '<div class="pr-drawer-empty">Could not load cart. <a href="/cart">View cart</a></div>';
      });
  }

  /* ── Update item quantity ────────────────────────────────── */
  function updateItem(key, quantity) {
    if (drawerBody) drawerBody.style.opacity = '0.5';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (cart && cart.currency) cartCurrency = cart.currency;
      if (drawerBody) drawerBody.style.opacity = '1';
      renderCart(cart);
    })
    .catch(function () {
      if (drawerBody) drawerBody.style.opacity = '1';
    });
  }

  /* ── Add to cart + open drawer ───────────────────────────── */
  function addToCartAndOpen(variantId, btn) {
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    if (drawerBody) drawerBody.innerHTML = '<div class="pr-drawer-loading">Loading…</div>';
    if (drawerFooter) drawerFooter.style.display = 'none';
    openDrawer();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Add failed');
      return r.json();
    })
    .then(function () {
      fetchCart(renderCart);
      btn.textContent = '✓ Added!';
      btn.style.background = '#1F8A4C';
      setTimeout(function () {
        btn.textContent = originalText;
        btn.style.background = '';
        btn.disabled = false;
      }, 2000);
    })
    .catch(function () {
      closeDrawer();
      btn.textContent = originalText;
      btn.disabled = false;
      window.location.href = '/cart/' + variantId + ':1?redirect=/cart';
    });
  }

  /* ── Cart Trigger (floating button) ─────────────────────── */
  function updateCartTrigger(cart) {
    var trigger = document.getElementById('prCartTrigger');
    var badge   = document.getElementById('prCartTriggerBadge');
    if (!trigger) return;
    var count = (cart && cart.item_count) ? cart.item_count : 0;
    if (count > 0) {
      trigger.style.display = 'flex';
      if (badge) badge.textContent = count;
    } else {
      trigger.style.display = 'none';
    }
  }

  function initCartTrigger() {
    var trigger = document.getElementById('prCartTrigger');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      fetchCart(function (cart) {
        renderCart(cart);
        openDrawer();
      });
    });
    /* Controlla il carrello ad ogni caricamento pagina */
    fetchCart(function (cart) {
      updateCartTrigger(cart);
    });
  }

  /* ── Init CTA buttons ────────────────────────────────────── */
  function initCartButtons() {
    document.querySelectorAll('.pr-btn[data-variant-id]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        addToCartAndOpen(btn.getAttribute('data-variant-id'), btn);
      });
    });
  }

  /* ── Testimonials Carousel ───────────────────────────────── */
  function initCarousel() {
    var track   = document.querySelector('.pr-t-track');
    var cards   = document.querySelectorAll('.pr-t-card');
    var prevBtn = document.querySelector('.pr-t-arrow.pr-t-prev');
    var nextBtn = document.querySelector('.pr-t-arrow.pr-t-next');

    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var index = 0;

    function visibleCount() { return window.innerWidth > 820 ? 2 : 1; }
    function maxIndex()     { return Math.max(0, cards.length - visibleCount()); }
    function update() {
      var gap       = 24;
      var cardWidth = cards[0].getBoundingClientRect().width;
      track.style.transform = 'translateX(-' + index * (cardWidth + gap) + 'px)';
      prevBtn.disabled = index <= 0;
      nextBtn.disabled = index >= maxIndex();
    }

    prevBtn.addEventListener('click', function () { if (index > 0)          { index--; update(); } });
    nextBtn.addEventListener('click', function () { if (index < maxIndex()) { index++; update(); } });
    window.addEventListener('resize', function () { if (index > maxIndex()) index = maxIndex(); update(); });
    update();
  }

  /* ── Smooth anchor scrolling ─────────────────────────────── */
  function initSmoothScroll() {
    document.querySelectorAll('.pr-landing a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var target = document.getElementById(this.getAttribute('href').slice(1));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ── Fade-in on scroll ───────────────────────────────────── */
  function initFadeIn() {
    if (!window.IntersectionObserver) return;
    var style = document.createElement('style');
    style.textContent = [
      '.pr-fade-target { opacity:0; transform:translateY(24px); transition:opacity .55s ease,transform .55s ease; }',
      '.pr-fade-target.pr-visible { opacity:1; transform:translateY(0); }'
    ].join('');
    document.head.appendChild(style);

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('pr-visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.08 });

    document.querySelectorAll('.pr-landing section').forEach(function (s) {
      s.classList.add('pr-fade-target');
      observer.observe(s);
    });

    var hero = document.querySelector('.pr-hero');
    if (hero) { hero.classList.add('pr-visible'); hero.style.opacity = '1'; hero.style.transform = 'none'; }
  }

  /* ── Social Proof Popup ──────────────────────────────────── */
  function initSocialPopup() {
    var popup       = document.getElementById('prPopup');
    var popupName   = document.getElementById('prPopupName');
    var popupTime   = document.getElementById('prPopupTime');
    var popupAvatar = document.getElementById('prPopupAvatar');
    var popupClose  = document.getElementById('prPopupClose');

    if (!popup) return;

    var names = [
      'Ashley M.', 'Jennifer R.', 'Sarah K.', 'Amanda L.', 'Jessica T.',
      'Stephanie H.', 'Michelle W.', 'Lisa B.', 'Angela C.', 'Melissa D.',
      'Lauren P.', 'Rachel N.', 'Megan S.', 'Christina F.', 'Brittany G.',
      'Nicole A.', 'Heather J.', 'Amber V.', 'Tiffany O.', 'Danielle E.'
    ];

    /* AU / CA / UK locations */
    var states = [
      'New South Wales', 'Victoria', 'Queensland', 'Western Australia', 'South Australia',
      'Ontario', 'British Columbia', 'Alberta', 'Quebec', 'Nova Scotia',
      'England', 'Scotland', 'Wales', 'Greater Manchester', 'Yorkshire'
    ];

    var colors = [
      '#1755B8', '#0E6655', '#7D3C98', '#B03A2E',
      '#1A5276', '#117A65', '#6E2F8F', '#935116'
    ];

    var lastIndex = -1;
    var hideTimer = null;
    var nextTimer = null;
    var dismissed = false;

    function rand(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function randomTime() {
      var mins = rand(1, 47);
      if (mins === 1) return 'just now';
      if (mins < 60) return mins + ' minutes ago';
      var hrs = Math.floor(mins / 60);
      return hrs === 1 ? '1 hour ago' : hrs + ' hours ago';
    }

    function pickIndex() {
      var i;
      do { i = rand(0, names.length - 1); } while (i === lastIndex);
      lastIndex = i;
      return i;
    }

    function showPopup() {
      if (dismissed) return;

      var i        = pickIndex();
      var name     = names[i];
      var state    = states[rand(0, states.length - 1)];
      var color    = colors[rand(0, colors.length - 1)];
      var initials = name.charAt(0);

      popupAvatar.textContent      = initials;
      popupAvatar.style.background = color;
      popupName.textContent        = name + ' from ' + state;
      popupTime.textContent        = randomTime();

      popup.classList.remove('pr-popup-hiding');
      popup.classList.add('pr-popup-visible');

      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () { hidePopup(); }, 3000);
    }

    function hidePopup() {
      popup.classList.add('pr-popup-hiding');
      popup.classList.remove('pr-popup-visible');

      clearTimeout(nextTimer);
      nextTimer = setTimeout(function () {
        popup.classList.remove('pr-popup-hiding');
        showPopup();
      }, rand(8000, 20000));
    }

    if (popupClose) {
      popupClose.addEventListener('click', function () {
        dismissed = true;
        clearTimeout(hideTimer);
        clearTimeout(nextTimer);
        popup.classList.add('pr-popup-hiding');
        popup.classList.remove('pr-popup-visible');
      });
    }

    setTimeout(showPopup, 4000);
  }

  /* ── Init ────────────────────────────────────────────────── */
  function init() {
    initCartTrigger();
    initCartButtons();
    initCarousel();
    initSmoothScroll();
    initFadeIn();
    initSocialPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
